#import "@/apollo/fragments/Job.gql"

query JobById($jobId: ID) {
    job(jobId: $jobId) {
        ...Job
    }
}
